import React,{useState,useEffect,useRef}from"react";
import {Link} from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import ImageUploading from 'react-images-uploading';
import Table from "../../../../../../core/dataTable/non-pager/index";
import ImageWithBasePath from "../../../../../../core/img";
import {all_routes} from "../../../../../router/all_routes";
import {Toaster} from 'react-hot-toast';
import {UrlQuery} from "biz9-react-utility";
import {Str,Obj,Log,Status_Type} from "biz9-utility";
import {Page_Logic,Portal_Type,Portal_Url,Portal_Title,Sub_Value_Logic,Portal_Value_Type,Portal_Page,Portal_Remote_Page,Portal_Remote_Data,Portal_Remote_CMS,Portal_Table,Portal_Field,Portal_Remote_Image,Sub_Value_Type} from "biz9-portal-app";
import {Image_Type,Image_Table,Image_Field,Image_Service,Image_Url,Image_Logic,Image_Format} from "biz9-image";
import {Message,Type,Url,Field,Title} from "../../../../../../constant";
import {App,Data,Dashboard,Event,Field_Logic,Image,Style,Service_Industry,User,Template,Toast_Message,Storage,System} from "../../../../../../project";
import {Data_Logic} from "biz9-data-app";
const async = require('async');
const Dashboard_App_Sub_Value_Edit_Pop_Open = () => {
    /* -- DEFINE --
     *
    */
    const query = UrlQuery();
    const [formNoDataShow, setFormNoDataShow] = useState(true);
    const [val_sub_page_title,setValSubPageTitle] =  useState("");
    const [val_event_handler,setValEventHandler] =  useState(query.get('event_handler'));
    const [sub_value,setSubValue] = useState(Sub_Value_Logic.get_new_sub_value(query.get('parent_table'),query.get('parent_id'),query.get('type'),query.get('value_id')));
    // -- text-edit-start -- //
    const [hide_text_edit,setHideTextEdit] = useState(true);
    const [val_text,setValText] = useState("");
    // -- text-edit-end -- //
    // -- image-edit-start -- //
    const [hide_image_edit,setHideImageEdit] = useState(true);
    const [hide_btn_image,setHideImageBtn] = useState(true);
    const [image,setImage] = useState([]);
    const image_max_count = 1;
    // -- image-edit-end -- //
    // -- group-edit-start -- //
    const [hide_group_edit,setHideGroupEdit] = useState(true);
    const [hide_group_add_btn,setHideGroupAddBtn] = useState(true);
    const [hide_group_back_btn,setHideGroupBackBtn] = useState(true);
    const [hide_group_table,setHideGroupTable] = useState(true);
    const [group_id,setGroupId] = useState(0);
    const [groups,setGroups] = useState([]);
    // -- group-edit-end -- //
    // -- group-edit-start -- //
    const [group_values,setGroupValues] = useState([]);
    const [hide_group_value_edit,setHideValueEdit] = useState(false);
    const [val_value_row_id,setValValueRowId] = useState(0);
    const [hide_group_value_image_edit,setHideGroupValueImageEdit] = useState(true);
    const [group_value_images,setGroupValueImages] = useState([]);
    // -- group-edit-end -- //
    useEffect(() => {
            Toast_Message.loading(Message.LOADING);
            if(sub_value.parent_id){
            get_data();
            }
            },[]);
    // -- LIST-GROUP-EDIT-START -- //
    const columns = [
    {
title: "Field",
           dataIndex: "title",
           key: "field",
           render: (text: string, record: any, index: number) => (
                   <h2 className="table-avatar d-flex align-items-center">
                   <Link onClick={(e)=>{{e.preventDefault();btn_edit_group(record[Field.GROUP_ID])}}} to={"#"} className="text-dark">
                   {index+1}{". "}{ record[Field.HEADER]? Str.get_truncate(!Str.check_is_image(record[Field.HEADER])? record[Field.HEADER] : '',99) :"empty"}

                   <img hidden={!Str.check_is_image(record[Field.HEADER])} src={Image.get_url(record[Field.HEADER],Image_Format.SQUARE_THUMB)} alt=""  height="200" width="200" />
                   </Link>
                   </h2>
                   )
    },
    {
title: "Action",
       dataIndex: "action",
       render: (res: string, record: any, index: number) => (
               <>
               <div className="dropdown dropdown-action">
               <Link to="#" className="action-icon" data-bs-toggle="dropdown" aria-expanded="false">
               <FeatherIcon icon="more-vertical" />
               </Link>
               <div className="dropdown-menu dropdown-menu-right">
               <Link className="dropdown-item" to="#" onClick={(e) => {{e.preventDefault();btn_copy_group(record[Field.GROUP_ID])}}}>
               <FeatherIcon icon="copy" /> Copy
               </Link>
               <Link className="dropdown-item" to="#" onClick={(e)=>{{e.preventDefault();btn_delete_group(record[Field.GROUP_ID])}}} >
               <FeatherIcon icon="trash" /> Delete
               </Link>
               </div>
               </div>
               </>
               ),
    },
    ];
    function bind_page_title(sub_value) {
        setValSubPageTitle(sub_value[Portal_Field.TITLE]);
    };
    async function get_data() {
        Toast_Message.loading(Message.LOADING);
        let query = {parent_id:sub_value.parent_id,parent_table:sub_value.parent_table,value_id:sub_value.value_id}
        let search = Data_Logic.get_search(Portal_Table.SUB_VALUE,query);
        let [response,data] = await Portal_Remote_Data.search(App.get_url(Portal_Url.DATA_SEARCH),search);

        bind_title('# '+sub_value.value_id);
        switch(sub_value.type){
            case Sub_Value_Type.TEXT:
                setHideTextEdit(false);
                if(data[Sub_Value_Type.ITEMS].length>0){
                    setSubValue(data[Sub_Value_Type.ITEMS][0]);
                    bind_text(data[Sub_Value_Type.ITEMS][0]);
                }
                break;
            case Sub_Value_Type.IMAGE:
                setHideImageEdit(false);
                setHideImageBtn(false);
                if(data[Sub_Value_Type.ITEMS].length>0){
                    setSubValue(data[Sub_Value_Type.ITEMS][0]);
                    bind_image(data[Sub_Value_Type.ITEMS][0]);
                }
                break;
            case Sub_Value_Type.ITEMS:
                setHideGroupAddBtn(false);
                if(data[Sub_Value_Type.ITEMS].length>0){
                    setSubValue(data[Sub_Value_Type.ITEMS][0]);
                    bind_groups(data[Sub_Value_Type.ITEMS][0]);
                }
                break;
        }
        Toast_Message.dismiss();
    };
    function bind_title(title){
        // -- bind-title --
        setValSubPageTitle(title);
    }
    function bind_text(sub_value){
        // -- value-text --
        if(!Str.check_is_null(sub_value.value)){
            setValText(sub_value.value);
        }
    }
    const updateValText = (event) => {
        setValText(event.target.value);
    };
    // -- TEXT-END -- //
    // -- IMAGE-START -- //
    function bind_image(sub_value){
        if(sub_value.value){
            setHideImageBtn(true);
            setImage([{image_filename:sub_value.value}]);
        }
    }
    async function onImageChange(image_upload, addUpdateIndex){
        Toast_Message.loading(Message.SAVING);
        setHideImageBtn(true);
        let image = Data_Logic.get(Image_Table.IMAGE,0,{data:{base64:image_upload[0][Image_Field.BASE64],extension:Str.get_file_extension(image_upload[0][Image_Field.FILE][Image_Field.NAME])}});
        let [response,data] = await Portal_Remote_Image.post(App.get_url(Portal_Url.IMAGE_POST),[image]);
        if(response.status == Status_Type.SUCCESS){
            setHideImageBtn(true);
            post_field(data[0].image_filename);
            setImage([data[0]]);
        }else{
            setHideImageBtn(false);
            Toast_Message.error(Message.ERROR);
        }
    };
    const onImageDelete = () => {
        if (window.confirm(Message.CONFIRM)) {
            setImage([]);
            setHideImageBtn(false);
            post_field("");
        }
    };
    // -- IMAGE-END -- //
    // -- GROUP-START -- //
    function bind_groups(sub_value){
        let groups = [];
        for(let a = 0; a < 30; a++){
            if(typeof sub_value[Field.GROUP+"_"+a] !== "undefined"){
                let new_group = {header:''};
                new_group[Field.GROUP_ID] = sub_value[Field.GROUP+"_"+a];
                groups.push(new_group);
            }
        }
        for(const group of groups){
            for(const value in sub_value){
                if(value.startsWith(Field.VALUE + "_" + group.group_id + "_")){
                    group.header = sub_value[value];
                    break;
                }
            }
        }
        setHideGroupBackBtn(true);
        setHideGroupEdit(true);
        setHideGroupAddBtn(false);
        setGroupValues([]);
        setGroups(groups);
        if(groups.length>0){
            setHideGroupTable(false);
        }
    };
    //9_group_add 9_add_group
    async function btn_add_group(){ //here1
        setHideGroupTable(false);
        setGroupValues([]);
        let new_group = get_new_group();
        setGroups(prevItems => [...groups, new_group]);
        sub_value[Field.GROUP+"_"+groups.length] = String(new_group.group_id);
        let [response,data] = await Portal_Remote_Data.post(App.get_url(Portal_Url.DATA_POST),sub_value.table,sub_value);
        setSubValue(data);
    };
    //9_group_copy 9_copy_group
    async function btn_copy_group(group_id){
        if(window.confirm(Message.CONFIRM)) {
            let new_group = get_new_group();
            let group_count = groups.length;
            sub_value[Field.GROUP+"_"+group_count] = String(new_group.group_id);
            for(const value in sub_value){
                let temp_id = Str.get_id();
                if(value.startsWith(Field.FIELD + "_" + group_id + "_")){
                    sub_value[Field.FIELD + "_" + String(new_group.group_id) + "_" + temp_id] = sub_value[value];
                    sub_value[Field.VALUE + "_" + String(new_group.group_id) + "_" + temp_id] = sub_value[value.replace(Field.FIELD,Field.VALUE)];

                }
            }
            let option = {overwrite:true,clean:true};
            let [response,data] = await Portal_Remote_Data.post(App.get_url(Portal_Url.DATA_POST),sub_value.table,sub_value,option);
            post_message_window(data);
            setGroups(prevItems => [...groups, new_group]);
            setSubValue(data);
            bind_groups(sub_value);
        }
    };
    //9_group_delete 9_delete_group
    async function btn_delete_group(group_id) {
        if(window.confirm(Message.CONFIRM)) {
            for(const value in sub_value){
                if(sub_value[value] == group_id){
                    delete sub_value[value];
                }
                else if(value.startsWith(Field.FIELD + "_" + group_id + "_")){
                    delete sub_value[value];
                }else if(value.startsWith(Field.VALUE + "_" + group_id + "_")){
                    delete sub_value[value];
                }
            }
            let option = {overwrite:true,clean:true};
            let [response,data] = await Portal_Remote_Data.post(App.get_url(Portal_Url.DATA_POST),sub_value.table,sub_value,option);
            post_message_window(data);
            setSubValue(data);
            bind_groups(sub_value);
        }
    };
    function get_new_group(){ //here1
        let new_group = Sub_Value_Logic.get_new_sub_value(query.get('parent_table'),query.get('parent_id'),query.get('type'),query.get('value_id'));
        new_group[Portal_Field.TITLE] = sub_value.title
            new_group[Field.GROUP_ID] = Str.get_id();
        return new_group;
    };
    //9_get_group_values
    function get_group_values(sub_value,group_id){
        let value = {};
        for(const value in sub_value){
            if(value.startsWith(Field.FIELD + "_" + group_id + "_")){
                let temp_id =  value.replace(Field.FIELD + "_" + group_id + "_","");
                let group_value = {temp_id:temp_id,field:sub_value[Field.FIELD + "_" + group_id + "_" + temp_id],value:sub_value[Field.VALUE + "_" + group_id + "_" + temp_id]};
                group_values.push(group_value);
            }
        }
        return group_values;
    };
    async function btn_edit_group_value_image(temp_id){
        setValValueRowId(temp_id);
        setHideGroupValueImageEdit(false);
        setHideGroupBackBtn(true);
        setHideGroupTable(true);
        setHideGroupEdit(true);
        setHideGroupAddBtn(true);
    };
    async function btn_group_value_image_back(){
        setHideGroupValueImageEdit(true);
        setHideGroupBackBtn(false);
        setHideGroupEdit(false);
    };
    async function btn_delete_group_value(temp_id){
        if (window.confirm(Message.CONFIRM)) {
            delete sub_value[Field.FIELD + "_" + group_id + "_" + temp_id];
            delete sub_value[Field.VALUE + "_" + group_id + "_" + temp_id];
            let option = {overwrite:true,clean:true};
            let [response,data] = await  Portal_Remote_Data.post(App.get_url(Portal_Url.DATA_POST),sub_value.table,sub_value,option);
            post_message_window(data);
            setSubValue(sub_value);
            setGroupValues(group_values.filter((row) => row[Field.TEMP_ID] !== temp_id));
        }
    };
    //9_group_edit
    async function btn_edit_group(group_id){
        Toast_Message.loading(Message.LOADING);
        setHideGroupBackBtn(false);
        setHideGroupTable(true);
        setHideGroupAddBtn(true);
        setHideGroupEdit(false);
        setGroupId(group_id);
        setGroupValues(get_group_values(sub_value,group_id));
        Toast_Message.dismiss();
    };
    const btn_add_group_value = () => {
        let new_group_value = {field:'',value:'',temp_id:Str.get_id(),group_id:group_id};
        setGroupValues([...group_values, new_group_value]);
    };
    const group_value_update = (field_type,temp_id,value,post_data) => {
        let new_value = [];
        if(field_type == Field.FIELD){
            new_value = group_values.map((row) => (row[Portal_Field.TEMP_ID] === temp_id ? { ...row, field:value } : row))
                setGroupValues(new_value);
        }else if(field_type == Field.VALUE || field_type == Image_Field.IMAGE_FILENAME){
            new_value = group_values.map((row) => (row[Portal_Field.TEMP_ID] === temp_id ? { ...row, value:value } : row))
                setGroupValues(new_value);
        }
        if(post_data){
            post_group_field(field_type,temp_id,value);
        }
    };
    async function onGroupValueImageChange(image_upload, addUpdateIndex){
        Toast_Message.loading(Message.SAVING);
        setHideGroupValueImageEdit(true);
        const mimeTypeSection = image_upload[0][Image_Field.BASE64].split(';')[0];
        const extension = mimeTypeSection.split('/')[1];
        let image = Data_Logic.get(Image_Table.IMAGE,0,{data:{base64:image_upload[0][Image_Field.BASE64],extension:Str.get_file_extension(image_upload[0][Image_Field.FILE][Image_Field.NAME])}});
        let [response,data] = await Portal_Remote_Image.post(App.get_url(Portal_Url.IMAGE_POST),[image]);
        if(response.status == Status_Type.SUCCESS){
            post_message_window(data[0]);
            btn_group_value_image_back();
            setHideGroupValueImageEdit(true);
            setHideGroupBackBtn(false);
            group_value_update(Field.VALUE,val_value_row_id,data[0].image_filename,true);
        }else{
            setHideGroupValueImageEdit(false);
            Toast_Message.error(Message.ERROR);
        }
    };
    const onGroupValueImageDelete = () => {
        if (window.confirm(Message.CONFIRM)) {
            setHideGroupValueImageEdit(false);
            setHideGroupEdit(false);
            group_value_update(Image_Field.IMAGE_FILENAME,val_value_row_id,"",true);
        }
    };
    const onGroupImageDelete = () => {
        if (window.confirm(Message.CONFIRM)) {
            setGroupValueImages([]);
            setHideGroupValueImageEdit(false);
            post_field("");
        }
    };
    //9_post_group 9_group_post
    async function post_group_field(field_type,temp_id,value){
        sub_value[field_type+"_"+group_id+"_"+temp_id] = value;
        let option = {overwrite:true,clean:true};
        let [response,data] = await Portal_Remote_Data.post(App.get_url(Portal_Url.DATA_POST),sub_value.table,sub_value,option);
        post_message_window(data);
        setSubValue(data);
        Toast_Message.success(response.message);
    };
    // -- GROUP-END -- //

    // -- OTHER-START -- //
    // 9_post
    async function post_field(value){
        sub_value[Field.VALUE] = value;
        let [response,data] = await Portal_Remote_Data.post(App.get_url(Portal_Url.DATA_POST),sub_value.table,sub_value);
        post_message_window(data);
        setSubValue(data);
        Toast_Message.success(response.message);
    };
    async function post_message_window(data){
        const send_data = {sub_value:data,event_handler:val_event_handler};
        if(window.opener){
            window.opener.postMessage(send_data,window.location.origin);
        }
    };
    async function btn_group_back_btn(){
        bind_groups(sub_value);
    };
    async function btn_close(){
        window.close();
    };
    const handle_submit = (event) =>{
        event.preventDefault();
    };
    // -- OTHER-END -- //
    return (
            <>
            <Toaster />
            {/* Page Content */}
            <div className="page-wrapper">
            <div className="page-content content bg-light">
            <div className="row justify-content-center">
            <div className="col-lg-10">
            <div className="main-title mb-4">
            <h4>{val_sub_page_title}</h4>
            </div>
            <div className="settings-info bg-white">
            <div className="tab-content">
            {/* General Tab  */}
            <div className="tab-pane fade show active" id="tab_general" role="tabpanel">
            <form onSubmit={handle_submit}>
            <div className="settings-card-body">

            {/* TEXT-EDIT-START */}
            <div className="row">
            <div className="col-md-12" hidden={hide_text_edit}>
            <div className="form-wrap mb-3">
            <input value={val_text}  onChange={updateValText} className="form-control text-area" placeholder="Value" onBlur={() => post_field(val_text)} />
            </div>
            </div>
            </div>
            {/* TEXT-EDIT-START */}
            {/* IMAGE-EDIT-START */}
            <div className="row">
                <div className="col-md-12" hidden={hide_image_edit}>
                <div className="form-wrap mb-3">
                <ImageUploading
                value={image}
            onChange={onImageChange}
            maxNumber={image_max_count}
            dataURLKey={Image_Field.BASE64}>
            {({
                    imageList,
                    onImageUpload,
                    onImageRemoveAll,
                    onImageUpdate,
                    isDragging,
                    dragProps,
                    }) => (
                        <div className="upload__image-wrapper">
                        <button hidden={hide_btn_image} className="btn btn-secondary mb-2"
                        style={isDragging ? { color: 'red' } : undefined} onClick={() =>  onImageUpload()}
                        {...dragProps} >
                        Image
                        </button>
                        &nbsp;
                        {imageList.map((image, index) => (
                                    <div key={index} className="image-item">
                                    <img  src={Image.get_url(image.image_filename,Image_Format.SQUARE_THUMB)} alt=""  height="200" width="200" />
                                    <div className="image-item__btn-wrapper">
                                    <Link onClick={() => onImageDelete() } to="#" className="mb-2" >
                                    <FeatherIcon icon="trash-2" />
                                    </Link>
                                    </div>
                                    </div>
                                    ))}
                        </div>
                        )}
            </ImageUploading>
                </div>
                </div>
                </div>
                {/* IMAGE-EDIT-END */}
            {/* GROUP-IMAGE-EDIT-START */}
            <div className="row">
                <div className="col-md-12" hidden={hide_group_value_image_edit}>
                <div className="form-wrap mb-3">
                <Link  onClick={(e)=>{{e.preventDefault();btn_group_value_image_back()}}} to={'#'} className="nav-link  mb-3" >
                {"<- Back"}
            </Link>
                <ImageUploading
                value={group_value_images}
            onChange={onGroupValueImageChange}
            maxNumber={image_max_count}
            dataURLKey={Image_Field.BASE64}>
            {({
                    imageList,
                    onImageUpload,
                    onImageRemoveAll,
                    onImageUpdate,
                    isDragging,
                    dragProps,
                    }) => (
                        <div className="upload__image-wrapper">
                        <button hidden={hide_group_value_image_edit} className="btn btn-secondary mb-2"
                        style={isDragging ? { color: 'red' } : undefined} onClick={() =>  onImageUpload()}
                        {...dragProps} >
                        Image
                        </button>
                        &nbsp;
                        {group_value_images.map((image, index) => (
                                    <div key={index} className="image-item">
                                    <img  src={Image.get_url(image.image_filename,Image_Format.SQUARE_THUMB)} alt=""  height="200" width="200" />
                                    <div className="image-item__btn-wrapper">
                                    <Link onClick={() => onGroupValueImageDelete() } to="#" className="mb-2" >
                                    <FeatherIcon icon="trash-2" />
                                    </Link>
                                    </div>
                                    </div>
                                    ))}
                        </div>
                        )}
            </ImageUploading>
                </div>
                </div>
                </div>
                {/* GROUP-IMAGE-EDIT-END */}
            {/* GROUP-EDIT-START */}
            <div className="form-wrap mb-3">
                <button hidden={hide_group_add_btn} onClick={() => btn_add_group()} className="btn btn-primary" type="submit">
                Add Group
                </button>
                </div>
                <div className="form-wrap mb-3" style={{ display:hide_group_table ? 'none' : 'block' }} >
                <Table allow_multiple={false} table={Portal_Table.BLANK} dataSource={groups} columns={columns} Selection={false} />
                </div>
                <div className="col-md-12" hidden={hide_group_edit}>
                <div className="form-wrap mb-3" style={{ display: !hide_group_back_btn ? 'block' :'none'  }} >
                <Link  onClick={(e)=>{{e.preventDefault();btn_group_back_btn()}}} to={'#'} className="nav-link" >
                {"<- Back"}
            </Link>
                </div>
                </div>
                {/* GROUP-VALUE-EDIT-START */}
            <div className="col-md-12" hidden={hide_group_edit}>
                <div className='biz_row_start'  >
                {group_values.map((row) => (
                            <div className="row">
                            <div className="col-md-12">
                            <div className="form-wrap">
                            <label className="col-form-label">
                            Field
                            </label>
                            <div className="form-wrap mb-1">
                            <input value={!Str.check_is_null(row[Field.FIELD])?row[Field.FIELD]:''} onChange={(e) => group_value_update(Field.FIELD,row[Portal_Field.TEMP_ID],e.target.value,false)} type="text" className="form-control" placeholder="Field" onBlur={(e) => group_value_update(Field.FIELD,row[Portal_Field.TEMP_ID],e.target.value,true)} />
                            </div>
                            </div>
                            <div className="form-wrap">
                            <label className="col-form-label">
                            Value
                            </label>
                            <div className="form-wrap">
                            <textarea hidden={Str.check_is_image(row[Field.VALUE])} value={row[Field.VALUE]} onChange={(e) => group_value_update(Field.VALUE,row[Portal_Field.TEMP_ID],e.target.value,false)} onBlur={(e) => group_value_update(Field.VALUE,row[Portal_Field.TEMP_ID],e.target.value,true)} className="form-control text-area" placeholder="Value"  />
                            </div>
                            </div>
                            </div>
                            <div style={{ textAlign: 'left' }}>
                            <Link onClick={(e)=>{{e.preventDefault(); btn_edit_group_value_image(row[Field.TEMP_ID])}}} to={"#"} className="mb-4" style={{ paddingRight:'10px' }} >
                            <FeatherIcon icon="camera" />
                            <img style={{ padding:"10px"}} hidden={!Str.check_is_image(row[Field.VALUE])}  src={Image.get_url(row[Field.VALUE],Image_Format.SQUARE_THUMB)} alt=""  height="200" width="200" />
                            </Link>
                            <Link  onClick={(e)=>{{e.preventDefault(); btn_delete_group_value(row[Field.TEMP_ID])}}}to="#" className="mb-4" >
                            <FeatherIcon icon="trash-2" />
                            </Link>
                            </div>
                            <hr/>
                            </div>
                            ))}
            <div className="review-btn text-center">
                <Link onClick={(e)=>{{ e.preventDefault();btn_add_group_value()}}} to={"#"} className="btn btn-dark text-white">
                {" "}
            <i className="ti ti-loader-3 me-1 rotate" /> Add Value{" "}
            </Link>
                </div>
                </div>
                </div>
                {/* GROUP-VALUE-EDIT-END */}

            </div>
                <div className="settings-card-footer">
                <div className="btn-item">
                <Link to="#" className="btn">
                </Link>
                <Link onClick={() => btn_close()} to={"#"} className="btn">
                Close
                </Link>
                </div>
                </div>
                </form>
                </div>
                </div>
                {/* /Page Content */}
            </div>
                </div>
                </div>
                </div>
                </div>
                {/* /Page Content */}
            </>
                );
};
export default Dashboard_App_Sub_Value_Edit_Pop_Open;
